<div class="requisition-table">
  <nz-tabset [nzSelectedIndex]="currentTab">
    @for (tab of requisitionTabsList; track tab; let tabIndex = $index) {
    <nz-tab nzTitle={{tab}} (nzClick)="onChangeRequisitionTab(tabIndex)">
      <nz-table #sortTable [nzData]="requisitionTableData" nzTableLayout="fixed" [nzNoResult]="emptyRequisitions"
        [nzScroll]="{ x: '950px' }" nzShowPagination="true" [nzLoading]="loading" [nzPageSize]="pageSize" nzFrontPagination="true"
        [nzTotal]="totalRequisitions">
        <thead>
          <tr>
            @for (column of requisitionColumnsList; track column.name) {
              @if (column.isVisible) {
                <th [nzWidth]="column.width" [nzAlign]="column.align === 'center' ? 'center'
                                          : column.align === 'right' ? 'right'
                                          : column.align === 'left' ? 'left'
                                          : null" style="white-space: pre-line;">
                  <div class="column-header">
                    {{ column.title }}
                    @if (column.name === 'totalCost') {
                      <span nz-icon nzType="question-circle"
                        nz-tooltip nzTooltipTitle="Monto requisitado"></span>
                    }
                  </div>
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (data of sortTable.data; track data.requisitionId; let rowIndex = $index) {
          <tr class="selectable-row" (click)="onGoToRequisitionDetails(data)">
            <td>
              <div class="requester-container">
                <div class="profile-image">
                  <img
                    src="{{data.userWhoRequests.img !== '' ? data.userWhoRequests.img : '../../../../assets/UserOutlined.svg'}}">
                </div>
                <div class="requester-info">
                  <span class="requester-name">{{ displayAuthIdentifier(data.userWhoRequests)}}</span>
                  <span>{{ data.userWhoRequests.role || 'No disponible'}}</span>
                </div>
              </div>
            </td>
             <td class="folio-column">
               {{ data.requisitionFolio | number : '3.0-0': 'en-US'}}
                @if (!currentRowElements[rowIndex]!.isFolioTooltipVisible) {
                  <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                    nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                    (click)="onCopyToClipboard(data.requisitionKey, rowIndex, $event)"></span>
                }
                @if (currentRowElements[rowIndex]!.isFolioTooltipVisible && currentTab === tabIndex) {
                  <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                    nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                    [nzTooltipVisible]="currentRowElements[rowIndex]!.isFolioTooltipVisible"
                    ></span>
                }
             </td>
            <td>
              <div class="id-column-container">
                <div class="info">
                  <span class="description">{{ data.requisitionDescription }}</span>
                </div>
                @if (data.requisitionIsHighlighted) {
                <button class="action-icon-buttons" nz-button nzType="text"
                  (click)="onHighlightRequisition(data, false, rowIndex, $event)"
                  nz-tooltip nzTooltipTitle="Eliminar de favoritos">
                  <span nz-icon nzType="star" nzTheme="outline"></span>
                </button>
                }
                @if (data.requisitionNotes && data.requisitionNotes !== '') {
                <button class="action-icon-buttons"
                  nz-button nzShape="circle" nzType="dashed"
                  (click)="onSelectNote(data.requisitionId, $event)"
                  nz-tooltip nzTooltipTitle="Ver nota">
                  <img class="icon action-icon-buttons" src="assets/TwoTone.svg">
                </button>
                }
              </div>
            </td>
            <td>
              <div class="id-column-container">
                <div class="info">
                  <span class="key">{{data.project.projectName}}</span>
                </div>
              </div>
            </td>
            <td nzAlign="center">
              {{ (data.requisitionApplicationDate | date: 'dd-MM-yyyy') || 'No disponible' }}
            </td>
            <td nzAlign="center">
              {{ (data.requisitionExpectedDeliveryDate| date: 'dd-MM-yyyy') || 'No disponible' }}
            </td>
            @if (requisitionColumnsList[requisitionColumnsEnum.TotalCost].isVisible) {
              <td nzAlign="right">{{(data.totalCost !== null) ? '$' : ''}}{{(data.totalCost | number : '1.2-2': 'en-US') ?? 'No disponible'}}</td>
            }
            <td>
              <div class="requester-container">
                <div class="profile-image">
                  <img
                    src="{{data.userWhoAuthorizes.img !== '' ? data.userWhoAuthorizes.img : '../../../../assets/UserOutlined.svg'}}">
                </div>
                <div class="requester-info">
                  <span class="requester-name">{{ displayAuthIdentifier(data.userWhoAuthorizes)}}</span>
                  <span>{{ data.userWhoAuthorizes.role || 'No disponible'}}</span>
                </div>
              </div>
            </td>
            <td nzAlign="center">
              <div class="priority-tag-container">
                <app-priority-tag [backgroundColor]="data.requisitionPriority.backgroundColor"
                  [borderColor]="data.requisitionPriority.borderColor" [label]="data.requisitionPriority.label"
                  [textColor]="data.requisitionPriority.textColor"></app-priority-tag>
              </div>
            </td>
            <td nzAlign="center">
              <app-status-tag [backgroundColor]="data.requisitionProgress!.backgroundColor"
                [borderColor]="data.requisitionProgress!.borderColor" [icon]="data.requisitionProgress!.icon"
                [label]="data.requisitionProgress!.label" [textColor]="data.requisitionProgress!.textColor"></app-status-tag>
            </td>
          </tr>
          @if (openedNotes.has(data.requisitionId)) {
            <tr class="note-row">
              <td class="note-info">
                <span>{{data.requisitionNotes}}</span>
                <button nz-button nzType="text" (click)="onCloseNote(data.requisitionId)">
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                </button>
              </td>
            </tr>
          }
          }
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>Total {{ totalRequisitions }} items</ng-template>
    </nz-tab>
    }
  </nz-tabset>
  <ng-template #emptyRequisitions>
    <nz-empty [nzNotFoundContent]="null" [nzNotFoundImage]="'assets/Empty.svg'">
    </nz-empty>
    <span>
      Aún no tienes requisiciones
    </span>
  </ng-template>
</div>

